import { PostsViewerSection } from '../PostsViewerSection/PostsViewerSection';

import { PostLikers } from './PostLikers/PostLikers';
import { usePostLikers } from './PostLikers/usePostLikers';

interface PostLikesViewProps {
  currentPostId: string;
  onBackButtonClick: () => void;
}

export const PostLikesView = ({
  currentPostId,
  onBackButtonClick: handleBackButtonClick,
}: PostLikesViewProps) => {
  const { likers, isLoading } = usePostLikers(currentPostId);

  return (
    <PostsViewerSection
      isLoading={isLoading}
      navigationLocationName="Likes"
      onBackButtonClick={handleBackButtonClick}
    >
      <PostLikers likers={likers} />
    </PostsViewerSection>
  );
};
